import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { combineLatest, map, Observable } from 'rxjs'
import { PulsarWebSocketService } from 'src/app/data/services/application/pulsar-websocket/pulsar-websocket.service'
import { ButtonColor, ButtonScale, ButtonVariant } from 'src/app/domain/enums/components/button.enum'
import { PrimeIcon } from 'src/app/domain/enums/components/prime-icons.enum'
import { HealthStatus, HealthStatusMessage } from 'src/app/domain/interfaces/application/pulsar-health.interface'
import { HealthStatusViewModel } from 'src/app/domain/interfaces/components/health-status-widget.interface'

@Component({ selector: 'app-health-status-widget', templateUrl: './health-status-widget.component.html', styleUrls: ['./health-status-widget.component.scss'], changeDetection: ChangeDetectionStrategy.OnPush })
export class HealthStatusWidgetComponent {
  private pulsarWebSocketService = inject(PulsarWebSocketService)

  serviceDisplayNames: Record<string, string> = { pyanalitics: 'Pyanalitics', octaremote: 'Octaremote', boreal: 'Boreal', linnks_api: 'CentralWeb', database: 'Zenith (BD)' }

  viewModel$: Observable<HealthStatusViewModel> = combineLatest([this.pulsarWebSocketService.healthStatus$, this.pulsarWebSocketService.connectionState$]).pipe(map(([healthStatus, isConnected]) => ({ healthStatus, isConnected, serviceEntries: healthStatus ? Object.entries(healthStatus.services) : [] })))

  buttonColor = ButtonColor
  ButtonVariant = ButtonVariant
  ButtonScale = ButtonScale
  primeIcon = PrimeIcon

  getOverallStatusClass(healthStatus: HealthStatusMessage | null): string {
    return this.getStatusClass(healthStatus?.overall_status)
  }

  getServiceStatusClass(status: HealthStatus): string {
    return this.getStatusClass(status)
  }

  private getStatusClass(status: HealthStatus | string | undefined): string {
    switch (status) {
      case 'ok':
        return 'status-ok'
      case 'degraded':
        return 'status-degraded'
      case 'down':
        return 'status-down'
      default:
        return 'status-unknown'
    }
  }

  getServiceDisplayName(serviceKey: string): string {
    return this.serviceDisplayNames[serviceKey] ?? serviceKey
  }

  requestCurrentStatus(): void {
    this.pulsarWebSocketService.requestCurrentStatus()
  }
}
